<template>
  <div>
    <ProducaoBar :is-midias-moderacao="false" :selected-tab-number="3" />
    <v-row class="ma-0 pa-5">
      <v-col>
        <CamerasRecebidas
          v-if="cod_producao && cameras"
          :data="cameras"
          :cod_producao="cod_producao"
          :current-cameras-page="page"
          :default-praca="producaoDefaultPraca"
        />
        <v-pagination
          v-if="cameras"
          class="mt-5"
          v-model="page"
          :length="cameras.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
      <v-col>
        <CamerasModeradas
          v-if="cod_producao && camerasEmExibicao"
          :cameras-em-exibicao="camerasEmExibicao"
          :moderadas-current-page="pageModerada"
        />
        <v-pagination
          v-if="camerasEmExibicao"
          class="mt-5"
          v-model="pageModerada"
          :length="camerasEmExibicao.totalPages || 1"
          @input="handleModeradasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProducaoBar from "../components/Producao/ProducaoBar.vue";
import CamerasModeradas from "@/components/Cameras/CamerasModeradas.vue";
import CamerasRecebidas from "@/components/Cameras/CamerasRecebidas.vue";

export default {
  name: "CamerasView",
  components: {
    ProducaoBar,
    CamerasRecebidas,
    CamerasModeradas,
  },
  data() {
    return {
      isDark: this.$vuetify.theme.dark,
      cod_producao: null,
      page: 1,
      pageModerada: 1,
      size: 5,
      paginasExibidas: 9,
      timerAprovada: null,
      timerModerada: null,
      producaoDefaultPraca: null,
    };
  },
  beforeCreate() {
    this.$store.commit("moderacao/setModoModeracao", 3);
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
  },
  async created() {
    const selectedProducao = this.$store.state.producoes.selectedProducao;
    if (selectedProducao?.cod_producao) {
      this.cod_producao = selectedProducao.cod_producao;
    }

    if (!this.cod_producao) {
      return; // nothing to load yet
    }
  },
  async mounted() {
    await this.getPracas(); // ensure pracas list exists
    await this.setDefaultPracaForProducao(); // sets store.selectedPraca

    // Now read from store with guards
    const selectedPraca = this.$store.state.cameras.selectedPraca;
    const selectedProducao = this.$store.state.producoes.selectedProducao;
    if (selectedPraca?.cod_praca && selectedProducao?.cod_producao) {
      await Promise.all([
        this.getCameras({
          page: 1,
          size: this.size,
          filtro_texto: this.filtroCameras,
          cod_praca: selectedPraca.cod_praca,
          cod_producao: selectedProducao.cod_producao,
        }),
        this.getCamerasEmExibicao({
          cod_producao: selectedProducao.cod_producao,
          page: this.pageModerada,
          size: this.size,
          filtro_texto: this.filtroCamerasEmExibicao,
        }),
      ]);

      this.getAllConfigsMosaico({ cod_producao: this.cod_producao });
      this.getPreferenciasMosaico({ cod_producao: this.cod_producao });

      this.updateTimers(); // only start timers once both sides are valid
    }
  },
  methods: {
    ...mapActions({
      getCameras: "cameras/getCameras",
      getCamerasEmExibicao: "cameras/getCamerasModeradas",
      getProducoes: "producoes/getProducoes",
      setSelectedPraca: "cameras/setSelectedPraca",
      getPracas: "pracas/getPracas",
      getAllConfigsMosaico: "mosaico/getAllConfigsMosaico",
      getPreferenciasMosaico: "mosaico/getPreferenciasMosaico",
    }),

    setDefaultPracaForProducao() {
      if (this.$store.state.cameras.selectedPraca) return;

      const producao = this.$store.state.producoes.selectedProducao;
      const listaPracas = this.$store.state.pracas.pracas;
      if (!producao || !producao.cod_praca || !Array.isArray(listaPracas)) return;

      const praca = listaPracas.find((p) => p.cod_praca === producao.cod_praca);
      if (praca) {
        this.setSelectedPraca(praca);
      }
    },
    changeTheme(e) {
      localStorage.setItem("@socialcam/is_dark_theme", e);
      this.$vuetify.theme.dark = e;
    },
    async handleAprovadasPageChange(newPage) {
      this.page = newPage;
      await this.getCameras({
        page: newPage,
        size: this.size,
        filtro_texto: this.filtroCameras,
        cod_praca: this.$store.state.cameras.selectedPraca.cod_praca,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.updateTimers();
    },
    async handleModeradasPageChange(newPage) {
      this.pageModerada = newPage;

      await this.getCamerasEmExibicao({
        cod_producao: this.cod_producao,
        size: this.size,
        filtro_texto: this.filtroCamerasEmExibicao,
        page: newPage,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.updateTimers();
    },

    updateTimers() {
      clearInterval(this.timerAprovada);
      clearInterval(this.timerModerada);
      clearInterval(this.timerTarja);

      // Timer for EnquetesRecebidas (left side)
      this.timerAprovada = setInterval(async () => {
        await this.getCameras({
          page: 1,
          size: this.size,
          filtro_texto: this.filtroCameras,
          cod_praca: this.$store.state.cameras.selectedPraca.cod_praca,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        });
      }, 60000); // 60 seconds for the left side

      // Timer for EnqueteEmExibicao (right side)
      this.timerModerada = setInterval(async () => {
        const cod_producao = this.$store.state.producoes.selectedProducao?.cod_producao;

        if (cod_producao) {
          try {
            await this.getCamerasEmExibicao({
              cod_producao: cod_producao,
              page: this.pageModerada,
              size: 5,
              filtro_texto: this.filtroCamerasEmExibicao,
            });
          } catch (error) {
            console.error("Erro ao buscar câmeras em exibição:", error);
          }
        }
      }, 60000); // 60 seconds for the right side
    },
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      cameras: "cameras/getterCameras",
      camerasEmExibicao: "cameras/getterCamerasEmExibicao",
      filtroCameras: "cameras/getterFiltroCameras",
      filtroCamerasEmExibicao: "cameras/getterFiltroCamerasModeradas",
      pracas: "pracas/getterPracas",
    }),
  },
  watch: {
    "$store.state.producoes.selectedProducao": async function (newValue, oldValue) {
      if (!newValue) return;
      this.cod_producao = newValue.cod_producao;
      this.producaoDefaultPraca = this.pracas?.find(
        (praca) => praca.cod_praca === newValue.cod_praca
      );
      // Only reset praça when production actually changes, not on tab restore
      if (!oldValue || oldValue.cod_producao !== newValue.cod_producao) {
        this.setSelectedPraca(this.producaoDefaultPraca);
      }
      this.page = 1;
      await this.getCameras({
        cod_praca: this.$store.state.cameras.selectedPraca?.cod_praca,
        cod_producao: newValue.cod_producao,
        page: this.page,
        size: this.size,
        filtro_texto: this.filtroCameras,
      });
      await this.getCamerasEmExibicao({
        cod_producao: newValue.cod_producao,
        page: this.pageModerada,
        size: 5,
        filtro_texto: this.filtroCamerasEmExibicao,
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.timerAprovada);
    clearInterval(this.timerModerada);
  },
};
</script>

<style lang="scss" scoped></style>
